import React, { useEffect, useRef, useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { api } from '../api/client';

// Grouped by what Stepan does: players day to day, the mobile app now and
// then, server internals rarely.
const NAV_GROUPS = [
  {
    title: 'Клуб',
    links: [
      { to: '/groups', label: 'Группы' },
      { to: '/coaches', label: 'Тренеры' },
      { to: '/parents', label: 'Родители' },
      { to: '/coach-salary', label: 'Зарплата тренеров' },
    ],
  },
  {
    title: 'Игроки',
    links: [
      { to: '/players', label: 'Список детей' },
      { to: '/players/new', label: 'Добавить игрока' },
      { to: '/player-rewards', label: 'Награды игроков' },
      { to: '/rewards', label: 'Каталог наград' },
      { to: '/monthly-winners', label: 'Победители месяца' },
    ],
  },
  {
    title: 'Тренировки',
    links: [
      { to: '/trainings', label: 'Расписание' },
      { to: '/gym-duties', label: 'Дежурства' },
      { to: '/normatives', label: 'Нормативы' },
      { to: '/places', label: 'Площадки' },
    ],
  },
  {
    title: 'Оплаты',
    links: [
      { to: '/invoices', label: 'Счета' },
      { to: '/payment-schedule', label: 'График счетов' },
      { to: '/fees', label: 'Стоимость' },
    ],
  },
  {
    title: 'Чаты',
    links: [{ to: '/chats', label: 'Чаты' }],
  },
  {
    title: 'Приложение',
    links: [
      { to: '/feature-toggles', label: 'Функции приложения' },
      { to: '/min-app-version', label: 'Минимальная версия' },
      { to: '/maintenance-mode', label: 'Техработы' },
    ],
  },
  {
    title: 'Сервер',
    links: [
      { to: '/settings', label: 'Настройки' },
      { to: '/scheduled-jobs', label: 'Фоновые задачи' },
    ],
  },
];

export default function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleRef = useRef<HTMLButtonElement>(null);
  const { pathname } = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (!menuOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      setMenuOpen(false);
      toggleRef.current?.focus();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [menuOpen]);

  return (
    <div className="layout">
      <nav className={menuOpen ? 'sidebar is-open' : 'sidebar'}>
        <div className="sidebar-header">
          <img src={`${process.env.PUBLIC_URL}/logo192.png`} alt="" />
          <div className="sidebar-brand">
            <h1>Викинги</h1>
            <span>Админка клуба</span>
          </div>
          <button
            ref={toggleRef}
            type="button"
            className="menu-toggle"
            aria-expanded={menuOpen}
            aria-controls="main-menu"
            aria-label={menuOpen ? 'Закрыть меню' : 'Открыть меню'}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              aria-hidden="true"
              focusable="false"
            >
              {menuOpen ? <path d="M6 6l12 12M18 6L6 18" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
            </svg>
          </button>
        </div>
        <div id="main-menu" className="sidebar-menu">
          <div className="nav-groups">
            {NAV_GROUPS.map((group) => (
              <div key={group.title} className="nav-group">
                <p className="nav-group-title">{group.title}</p>
                <ul>
                  {group.links.map((link) => (
                    <li key={link.to}>
                      <NavLink to={link.to} end>
                        {link.label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <button className="logout-btn" onClick={api.logout}>
            Выйти
          </button>
        </div>
      </nav>
      {menuOpen && (
        <div className="menu-backdrop" aria-hidden="true" onClick={() => setMenuOpen(false)} />
      )}
      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
